import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SharedService } from '../../../component/shared/shared.service';
import { ActivatedRoute } from '@angular/router';
import { User } from '../../user/model/user';
import { UserDetail } from '../../user/model/user-detail';
import { UserService } from '../../user/service/user.service';
import { DialogAction, ActionMessage } from '../../../shared/enum/dialog-action.enum';
import { AuthServiceService } from '../../../component/service/auth-service.service';
import { TimeSlot } from '../../master/model/time-slot';
import { TimeslotMasterService } from '../../master/services/timeslot-master.service';
import { Clinic } from '../../master/model/clinic';
import { ClinicMasterService } from '../../master/services/clinic-master.service';
import { Appointment, Schedule } from '../model/appointment';
import { AppointmentService } from '../service/appointment.service';
import { IMyDrpOptions } from 'mydaterangepicker';
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
import * as $ from 'jquery';
import * as moment from 'moment';
import { OnChanges } from '@angular/core/src/metadata/lifecycle_hooks';

@Component({
  selector: 'app-doctor-schedule',
  templateUrl: './doctor-schedule.component.html',
  styleUrls: ['./doctor-schedule.component.css']
})
export class DoctorScheduleComponent implements OnInit {
  authService : AuthServiceService;
  usrData: UserDetail ;
  loading: boolean = false;
  slotmessage: string = '';
  message: string = '';
  Users : UserDetail[];
  selectedObject : UserDetail;
  Userloading : boolean = false;
  schedulingLoading : boolean = false;
  isAdd : boolean = true;
  isErrorMessage : boolean = false;
  isSuccessMessage : boolean = false;
  isSlotErrorMessage : boolean = false;
  isSlotSuccessMessage : boolean = false;
  id: number;
  timeSlotsData : Schedule[];
  clinics :Clinic[]; 
  clinicsData :Clinic[]; 
  schedule : Schedule;
  user: any;
  private sub: any;
  calendarOptions:any = {};
  appointment : Appointment ;
  appointmentData :Appointment[]; 
  scheduleData : Schedule[];
  appointmentDay : any = {};
  appointmentCopyDay: any = {};
  scheduleDate : any = {};
  scheduleClinicId : number = null;
  scheduleLoading : boolean = false;
  selectedScheduleObject : any = {};
  appDate : any;
  isSuperAdmin : boolean = false;
  isDoctor : boolean = false;
  isBDA : boolean = false;
  isAssistant : boolean = false;
  isAbsenceShow : boolean = false;
  isSlotSave: boolean = false;
  isSlotLoaded: boolean = false;
  scheduleList:any=[];
  myDateRangePickerOptions: IMyDrpOptions = {
    dateFormat: 'dd/mm/yyyy',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    height: '100%',
    width: '100%',
    inline: true,
    alignSelectorRight: false,
    indicateInvalidDateRange: true
   };
   scheduleDateOption: IMyDrpOptions = {
    dateFormat: 'dd/mm/yyyy',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    height: '100%',
    width: '100%',
    inline: false,
    alignSelectorRight: false,
    indicateInvalidDateRange: true 
   };
   copyDateOption: IMyDrpOptions = {
    dateFormat: 'dd/mm/yyyy',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    height: '100%',
    width: '100%',
    inline: false,
    alignSelectorRight: false,
    indicateInvalidDateRange: true 
   };
   dtOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'dd/mm/yyyy',
  };
  constructor(authorizationService : AuthServiceService, private _sharedService: SharedService, private _usrService : UserService,private route: ActivatedRoute, private _srvTimeSlot : TimeslotMasterService, private _clinicService : ClinicMasterService, private _appService : AppointmentService) { 
    this.appointment  =  new  Appointment(null,null,'',null,'',null,'',null,'','',null,'','','',null,'',false,'',false,'','','','','',false,false,'',0.0);
    this.authService = authorizationService;
    if(this.authService.getUserRole() === "1") {
      this.isSuperAdmin = true;
   } else if(this.authService.getUserRole() === "2") {
     this.isDoctor = true;
   } else if(this.authService.getUserRole() === "3") {
    this.isAssistant = true;
  } else if(this.authService.getUserRole() === "4") {
    this.isBDA = true;
  }
    _sharedService.yesEmitted$.subscribe(
      text => {
          if(text.Action===DialogAction.DELETE.toString()  && text.Page === 'DOCTOR SCHEDULE') {
              this.deleteScheduleData();
          } if(text.Action===DialogAction.DELETE.toString()  && text.Page === 'DOCTORDEACTIVE') {
             this.deactiveData();
          }  if(text.Action===DialogAction.DELETE.toString()  && text.Page === 'APPOINTMENTDOCCANCELE') {
                this.cancelAppointmentData();
           }  else {
              this.selectedScheduleObject = {};
          }
      });
      _sharedService.bookingEmitted$.subscribe(
        text => {
           
            this.searchSchedule();
          
        });
        let dt = new Date();
        this.appDate =  { date: { year: dt.getFullYear(), month: dt.getMonth() + 1, day: dt.getDate() } };
  }
  getClinic() : void {
    this.loading = true;
    this._clinicService.getClinic().subscribe(data=>{
      this.loading = false;
      this.clinics  = data;
    },
    error=>{
        this.loading = false;
        this.message = error.data;
    });
}
deactiveData() : void {
  this.scheduleLoading = true;
  let date = this.selectedScheduleObject.date;
  let time = this.selectedScheduleObject.time;
  this._appService.deactivateSchedule(this.usrData.UserId,this.scheduleClinicId ,date, time).subscribe(data => {
   this.message = "Deactivates successfully!" ;
   this.isSuccessMessage = true;
   let scDate  = this.scheduleData.filter(function(data){
    return (data.StartDate === date)
  })
  if(scDate.length>0){
    var schData = scDate[0].AppointmentSchedule.filter(function(data){
      return (data.AppointmentTime === time)
    })
    if(schData.length>0) {
      schData[0].AppointmentIsScheduledActive = false;
    }
  }
   this.searchSchedule();
   this.hideMessage() ;
  }, error => {
   this.message = error.data ;
   this.isErrorMessage = true;
   this.scheduleLoading = false;
   this.hideMessage() ;
  });
}

activateSchedule(day : string, scTime : string) : void {
  this.scheduleLoading = true;
  let date = day;
  let time = scTime;
  this._appService.activateSchedule(this.usrData.UserId,this.scheduleClinicId ,date, time).subscribe(data => {
   this.message = "Activated successfully!" ;
   this.isSuccessMessage = true;
   let scDate  = this.scheduleData.filter(function(data){
    return (data.StartDate === date)
  })
  if(scDate.length>0){
    var schData = scDate[0].AppointmentSchedule.filter(function(data){
      return (data.AppointmentTime === time)
    })
    if(schData.length>0) {
      schData[0].AppointmentIsScheduledActive = true;
      schData[0].AppointmentIsBooked = false;
      schData[0].AppointmentIsCancelled = false;
    }
  }
   this.searchSchedule();
   this.hideMessage() ;
  }, error => {
   this.message = error.data ;
   this.isErrorMessage = true;
   this.scheduleLoading = false;
   this.hideMessage() ;
  });
}

setClinic( UserData : UserDetail) {
  /*this.clinicsData = [];
   let clicData = this.clinics.filter(function(clinic){
       return (clinic.OrganizationId === UserData.OrganizationId);
   });
   
    for(let i=0; i < UserData.UserClinic.length; i++) {
         let cData = clicData.filter(function(clinic){
            return (clinic.ClinicId === UserData.UserClinic[i].AssociateClinicId);
         });
         if(cData.length>0) {
           this.clinicsData.push(cData[0]);
         }
         
    }
    this.schedule = new Schedule('','',null, true, true, true, true, true, true, false);
    window.setTimeout(function(){
      $('#timeMon').click();
      $('#timeTue').click();
      $('#timeWed').click();
      $('#timeThu').click();
      $('#timeFri').click();
      $('#timeSat').click();
    },0)*/

    this.getTimeSlotDetail(UserData.UserId);
    
}
  getUsers(id : number) : void {
    if(this.isDoctor) {
      this.user = JSON.parse(sessionStorage.getItem("User"));
      if(this.user=== undefined || this.user=== null) {
      this._usrService.getUserProfile().subscribe(data=>{
        if(data.length>0) {
          sessionStorage.setItem("User",JSON.stringify(data[0]));
          this.usrData = data[0];
              this.hoveredDivId = this.usrData.UserId;
              this.setClinic(this.usrData);
        
        }})
      } else {
        this.usrData = this.user;
        this.hoveredDivId = this.usrData.UserId;
        this.setClinic(this.usrData);
      }
    } else {

    this.Userloading = true;
    this._usrService.getUsersList().subscribe( data=> {
     
      this.Users = data.filter((usr) => usr.UserRoleId == 2 &&  usr.IsDeleted==0 && usr.UserActive ==1)
      if(id != undefined && id != null){
          var data = this.Users.filter(function(user){
            return (user.UserId === id);
          })
          if(data.length>0){
            this.usrData = data[0];
            this.hoveredDivId = this.usrData.UserId;
            this.setClinic(this.usrData)  ;
           // this.getTimeSlotDetail(id);
          } 

      } else {
        if(this.Users.length>0) {
          this.getTimeSlotDetail(this.Users[0].UserId);
        }
      }
      this.Userloading = false;
    },
    error=>{
        this.loading = false;
        this.message = error.data;
    });
  }
  }
  getTimeSlotDetail(id: number) : void {
    this.schedulingLoading = true;
     this._srvTimeSlot.getSceduleTimeSlots(id).subscribe(
       data=>{
           this.schedulingLoading = false;
           console.log(data);
           this.timeSlotsData  = data;
       },
       error=>{
          this.schedulingLoading = false;
       }
     );
  } 
  hideMessage() : void {
    setTimeout(() => {
      this.isErrorMessage  = false;
      this.isSuccessMessage  = false;   
      this.message = '';
      this.isSlotErrorMessage  = false;
      this.isSlotSuccessMessage  = false;   
      this.slotmessage = '';
    }, 5000);
  }

  ClearData() : void {
    for(let i=0; i<this.timeSlotsData.length;i++) {
      this.timeSlotsData[i]['isChecked'] = false;
    }
    this.appointment.AppointmentClinicId = null;
  }

  saveSchedule() {
    this.schedulingLoading = true;
     this._srvTimeSlot.saveSchedule(this.timeSlotsData).subscribe(
       data=>{
        this.schedulingLoading = false;
          
       },
       error=>{
        this.schedulingLoading = false;
       }
     );
  }

  saveDoctorSchedule(): void {
    this.message = '';
    if (this.appointment.AppointmentClinicId === null || this.appointment.AppointmentClinicId === 0) {
       this.message = 'Please select clinic!'; 
       this.isErrorMessage = true;
       return;
    }
    this.appointmentData = [];
    
    for(let i=0; i<this.timeSlotsData.length;i++) {
       if(this.timeSlotsData[i]['isChecked']) {
           var appointment = new  Appointment(null,this.usrData.UserId,this.usrData.UserName,this.timeSlotsData[i].SlotId,this.timeSlotsData[i].SlotDescription ,this.appointment.AppointmentClinicId,'',null,'','',null, '',this.timeSlotsData[i].SlotDescription,'',null,'',false,'',false,'','','','','',false,false,'',0.0);
           this.appointmentData.push(appointment);
       }
    }
     if(this.appointmentData.length===0){
        this.message = 'Please select atleast one time slot!'; 
        this.isErrorMessage = true;
        return;
     }
    this.schedulingLoading = true;
    var selectedDate =  this.appointmentDay.formatted.split('-');
    this.schedule.StartDate = selectedDate[0];
    if(selectedDate.length ==2 && selectedDate[1] !== 'Select End Date') {
      this.schedule.EndDate = selectedDate[1];
    }
    this.schedule.AppointmentSchedule = this.appointmentData;
    
    this._appService.data = this.schedule;
    this._appService.saveSchedule().subscribe(data=>{
      this.schedulingLoading = false;
      this.message = 'Dosctor schedule '+ ActionMessage.SAVESUCCESS.toString();
      this.isSuccessMessage  =true;
      this.isErrorMessage = false;
      this.hideMessage() ;
      this.ClearData();
      this.cancelData();
    },
    error=>{
        this.schedulingLoading = false;
        this.message = error.data;
        this.isSuccessMessage  =true;
        this.isErrorMessage = true;
        this.hideMessage() ;
    });
  }
  color:string = 'doc-list hoverList';
  defaultStyle:string = 'doc-list outList';
  hoveredDivId :number;
  changeStyle($event, id, index){
    $event.type == 'mouseover' ? this.hoveredDivId = id : this.hoveredDivId = null;      
  }
  cancelAppointmentData() {
    this.scheduleLoading = true;
    let date = this.selectedScheduleObject.date;
    let time = this.selectedScheduleObject.time;
    this._appService.cancelAppointment(this.usrData.UserId,this.scheduleClinicId ,date, time ).subscribe(data=>{
        this.isSuccessMessage = true;
        this.scheduleLoading = false;
        this.searchSchedule();
        this.message = "Appointment canceled successfully";
        this.hideMessage() ;
    }, error=> {
      this.isErrorMessage = true;
      this.message = "Appointment not canceled";
      this.hideMessage() ;
    })
 }
  cancelAppointment(date : string, time : string) {
    this.selectedScheduleObject = {'date' : date, 'time' : time};
   
    this._sharedService.emitDialog(true, "Cancel", ActionMessage.CANCEL.toString(),true,DialogAction.DELETE.toString(), 'APPOINTMENTDOCCANCELE' );  

  }
  ngOnInit() {
    var id : number;
    this.sub = this.route.params.subscribe(params => {
       id = +params['id'];
    });
    this.getClinic();
    this.getUsers(id);
    
   
  }
  deleteScheduleData() {
     this.scheduleLoading = true;
     let app  =  new  Appointment(null,null,'',null,'',null,'',null,'','',null,this.selectedScheduleObject.date,this.selectedScheduleObject.time,'',null,'',false,'',false,'','','','','',false,false,'',0.0);
     this._appService.appointmentData = app;
     this._appService.deleteAbsence().subscribe(data => {
      this.message = "Deleted successfully!" ;
      this.isSuccessMessage = true;
      
      this.searchSchedule();
      this.hideMessage() ;
     }, error => {
      this.message = error.data ;
      this.isErrorMessage = true;
      this.scheduleLoading = false;
      this.hideMessage() ;
     });
  }

  deleteSchedule(date : string, time : string) {
    this.selectedScheduleObject = {'date' : date, 'time' : time};
    this._sharedService.emitDialog(true, "Delete", ActionMessage.DELETE.toString(),true,DialogAction.DELETE.toString(), 'DOCTOR SCHEDULE' );      
  }
  addSchedule () {
    this.message = '';
    this.isErrorMessage = false;
    this.isSuccessMessage = false;
  }
  showSchedule () {
    this.message = '';
    this.isErrorMessage = false;
    this.isSuccessMessage = false;
    this.isAbsenceShow = false;
  }

  searchSlots() {
    if(this.scheduleDate === null || this.scheduleDate.formatted === undefined || this.scheduleDate.formatted === '') {
      this.message = 'Please select date !';
      this.isErrorMessage = true;
      this.hideMessage() ;
      return;
    }
    this.scheduleLoading = true;
    this.isSlotLoaded = false;
    var selectedDate =  this.scheduleDate.formatted.split('-');
    let StartDate = this.scheduleDate.beginDate.year +"-" + this.scheduleDate.beginDate.month  +"-" +this.scheduleDate.beginDate.day;
    let EndDate = StartDate;
    if(selectedDate.length == 2 && selectedDate[1] !== 'Select End Date') {
      EndDate = this.scheduleDate.endDate.year +"-" + this.scheduleDate.endDate.month  +"-" +this.scheduleDate.endDate.day;
    }
      this._appService.getDoctorScheduleForAbsence(StartDate, EndDate).subscribe(
        data=> {
          this.isSlotLoaded = true;
           this.scheduleList = data.Item;
           this.scheduleLoading = false;
           this.scheduleList.forEach(element => {
            let count = 0;
            element.isFull = element.isFull.toString();
            element.applist.forEach(slot => {
              if(slot.IsOrderCancel==1) {
                slot.IsChecked =true;
                count++;
              }
              else {
                slot.IsChecked =false;
              }
            })
           if(count==0){
            element.isFull = "-1";
           }
          })
        },
        error=>{
          this.scheduleLoading = false;
        }
      );
  }
  searchSchedule() {
    if(this.scheduleDate === null || this.scheduleDate.formatted === undefined || this.scheduleDate.formatted === '') {
      this.message = 'Please select date !';
      this.isErrorMessage = true;
      this.hideMessage() ;
      return;
    }
    /*if (this.scheduleClinicId === null || this.scheduleClinicId === 0) {
      this.message = 'Please select clinic !';
      this.isErrorMessage = true;
      this.hideMessage() ;
      return;
   }*/
   this.scheduleLoading = true;
    var selectedDate =  this.scheduleDate.formatted.split('-');
    let StartDate = this.scheduleDate.beginDate.year +"-" + this.scheduleDate.beginDate.month  +"-" +this.scheduleDate.beginDate.day;
    let EndDate = StartDate;
    if(selectedDate.length == 2 && selectedDate[1] !== 'Select End Date') {
      EndDate = this.scheduleDate.endDate.year +"-" + this.scheduleDate.endDate.month  +"-" +this.scheduleDate.endDate.day;
    }
      this._appService.getDoctorAbsenceMultipleDay(StartDate, EndDate).subscribe(
        data=> {
           this.scheduleData = data.Item;
           this.scheduleLoading = false;
           this.scheduleList.forEach(element => {
             let count = 0;
            element.isFull = element.isFull.toString();
            element.applist.forEach(slot => {
              if(slot.IsOrderCancel==1) {
                slot.IsChecked =true;
                count++;
              }
              else {
                slot.IsChecked =false;
              }
            })
           if(count==0){
            element.isFull = "-1";
           }
          })
        },
        error=>{
          this.scheduleLoading = false;
        }
      );
  }
  clickday(date, jsEvent, view): void {
    this.appointmentDay = JSON.stringify(date);
   
  }
  ngAfterViewChecked() {
    this._sharedService.emitChange(false);
  }
  ngOnDestroy() {
    this._sharedService.emitChange(true);
  };
  getDoctorSchedule() : void {
     /*this._appService.getDoctorScheduleForDay().subscribe(
       data => { this.appointmentData = data; },
       error => {}
     );*/
  }
  cancelData() : void {
    for(let i=0; i<this.timeSlotsData.length;i++) {
       this.timeSlotsData[i]['isChecked'] = false;
    }
    this.schedule.isFriday = false;
    this.schedule.isMonday = false;
    this.schedule.isSaturday = false;
    this.schedule.isSunday = false;
    this.schedule.isThursday = false;
    this.schedule.isTuesday = false;
    this.schedule.isWedneday = false;
    this.appointmentDay = {};
    this.appointmentCopyDay = {};
    this.appointment.AppointmentClinicId = null;
    $('.headerclearbtn').click();
  }
  bookAppointment(date :string, time : number) {
    this._sharedService.overlay( {'module' :'USER','type' : 'Appointment','isShow' : true,'data' : this.usrData, 'secondData' : null, 'thirdData' : {date : date, time :time}});
  }
  deactivateSchedule(date : string, time : string) {
    this.selectedScheduleObject = {'date' : date, 'time' : time};
    this._sharedService.emitDialog(true, "Deactivate", ActionMessage.DEACTIVATE.toString(),true,DialogAction.DELETE.toString(), 'DOCTORDEACTIVE' );  
  }
  copyDoctorSchedule() : void {
    
    if(this.appDate === null) {
      this.message = 'Please select schedule date!'; 
      this.isErrorMessage = true;
      return;
    }
    
    if(this.appointmentCopyDay === null || this.appointmentCopyDay.formatted === '') {
      this.message = 'Please select copy date range !';
      this.isErrorMessage = true;
      this.hideMessage() ;
    }
    if(this.scheduleClinicId === null || this.scheduleClinicId === 0) {
      this.message = 'Please select clinic !';
      this.isErrorMessage = true;
      this.hideMessage() ;
    }
    var selectedDate =  this.appointmentCopyDay.formatted.split('-');
    this.schedule.StartDate = selectedDate[0];
    if(selectedDate.length ==2 && selectedDate[1] !== 'Select End Date') {
      this.schedule.EndDate = selectedDate[1];
    } else {
      this.schedule.EndDate = selectedDate[0];
    }
    this.schedule.AppointmentSchedule = this.appointmentData;
    this.schedulingLoading = true;
    let date = this.appDate.date.day + '/' + this.appDate.date.month + '/'+ this.appDate.date.year;
    this.schedule.Day =  date;
    this.schedule.DoctorId =  this.usrData.UserId;
    this.schedule.ClinicId =  this.scheduleClinicId;
    this._appService.data = this.schedule;
    this._appService.copySchedule().subscribe(data=>{
      this.schedulingLoading = false;
      this.message = 'Dosctor schedule '+ ActionMessage.COPYSUCCESS.toString();
      this.isSuccessMessage  =true;
      this.isErrorMessage = false;
      this.hideMessage() ;
       this.appDate= '';
       this.appointmentCopyDay = {};
    },
    error=>{
        this.schedulingLoading = false;
        this.message = error.data;
        this.isSuccessMessage  =true;
        this.isErrorMessage = true;
        this.hideMessage() ;
    });
  }

  setFalse(element: any) {
    element.applist.forEach(slot => {
      slot.IsChecked = false;
    });
  }
  saveAbsence() {
    this.isSlotSave = true;
    this.scheduleList.forEach(element => {
      element.applist.forEach(slot => {
        if(element.isFull==1) {
          slot.IsOrderCancel =1
        }
        else if(element.isFull==0)
        {
          if(slot.IsChecked) {
            slot.IsOrderCancel =1
          }
          else {
            slot.IsOrderCancel =0
          }
        } else{
          slot.IsOrderCancel =0;
        }
       
      });
    });
    var selectedDate =  this.scheduleDate.formatted.split('-');
    let StartDate = this.scheduleDate.beginDate.year +"-" + this.scheduleDate.beginDate.month  +"-" +this.scheduleDate.beginDate.day;
    let EndDate = StartDate;
    if(selectedDate.length == 2 && selectedDate[1] !== 'Select End Date') {
      EndDate = this.scheduleDate.endDate.year +"-" + this.scheduleDate.endDate.month  +"-" +this.scheduleDate.endDate.day;
    }
    let data = {
      "StartDate" : StartDate,
      "EndDate" : EndDate,
      "applist" : this.scheduleList
    }

    this._appService.saveAbsence(data).subscribe(data=>{
      this.isSlotSave = false;
      this.slotmessage = 'Absence Added Successfully';
      this.isSlotSuccessMessage  =true;
      this.isSlotErrorMessage = false;
      this.hideMessage() ;
      this.searchSlots();
    },
    error=>{
        this.isSlotSave = false;
        this.slotmessage = error.data;
        this.isSlotSuccessMessage  =true;
        this.isSlotErrorMessage = true;
        this.hideMessage() ;
    });
  }
 
}



// WEBPACK FOOTER //
// ./src/app/section/appointment/doctor-schedule/doctor-schedule.component.ts